import type { AppState } from '../types/quiz';
import type { TakeQuizQuestion, QuizGeneralSettings,QuizBrowserSettings, QuizResult } from '../types/takeQuiz';
export const initialState: AppState = {
  user: null,
  token: null,
  navbarActiveTab: '',
  firstQuestionId: 0,
  currentQuestionId: null,
  isFromCreateQuiz: false,
  quizReportsFilter: {
    start_time: '',
    end_time: '',
    filterValueKey: 'ALL'
  },
  isLoading: false,
  error: null,
  quizQuestions: [],
  isExplanationOn: false,
  imagePath: '',
  isQuestionPopupOpen: false,
  quizTitle: '',
  errorNotification: null,
   
  // Take Quiz State
  
  takeQuizQuestion: {} as TakeQuizQuestion,
  quizGeneralSettings: {} as QuizGeneralSettings,
  quizBrowserSettings: {} as QuizBrowserSettings,
  quizResult: {} as QuizResult,
  quizProgress: 0,
  currentQuizResultId: '',
  userOfflineCount: 0,
  completeQuestion: 0,
  isTimeoutForceSubmit: false,
  isSecuritySubmit: false,
  isVideoModalOpen: false,
};